if ( typeof ImageHotspots !== 'function' ) {

  class ImageHotspots extends HTMLElement {

    constructor(){

      super();

			this._prefix = window.KT_PREFIX || '';

      this.daysEl = this.querySelector('.days');
			this.zIndex = 9;

      this.hotspots = this.querySelectorAll(
				`.${this._prefix}image-hotspots__spot--bullet`
			);
			let previoushotspot = null;

			this.hotspots.forEach((hotspot) => {
				hotspot.addEventListener("click", (event) => {
					if (previoushotspot && previoushotspot !== event.target) {
						previoushotspot.classList.remove("active");
					}
					event.target.classList.toggle("active");
					event.target.parentNode.style.zIndex = this.zIndex++;

					// Check and fix tooltip position on mobile
					if (window.innerWidth <= 767) {
						setTimeout(() => this.adjustTooltipPosition(event.target.parentNode), 10);
					}

					previoushotspot = event.target;
					event.stopPropagation();
				});
			});

			document.addEventListener("click", (event) => {
				this.hotspots.forEach((hotspot) => {
					hotspot.classList.remove("active");
				});
				previoushotspot = null;
			});

			// Handle responsive image width
			this.initResponsiveWidth();

			// Handle auto-open tooltips
			this.initAutoOpen();

			// Handle auto-play demo
			this.initAutoPlay();

    }

		adjustTooltipPosition(spotElement) {
			if (!spotElement || window.innerWidth > 767) return;

			const tooltip = spotElement.querySelector('.image-hotspots__spot--content');
			if (!tooltip || !tooltip.classList.contains('active') &&
					!tooltip.parentElement.querySelector('.image-hotspots__spot--bullet.active')) {
				return;
			}

			const tooltipRect = tooltip.getBoundingClientRect();
			const viewportWidth = window.innerWidth;
			const padding = 20; // Minimum padding from viewport edge

			// Check if tooltip overflows on the right
			if (tooltipRect.right > viewportWidth - padding) {
				const overflow = tooltipRect.right - (viewportWidth - padding);
				tooltip.style.transform = `translateX(-${overflow}px)`;
			}

			// Check if tooltip overflows on the left
			if (tooltipRect.left < padding) {
				const overflow = padding - tooltipRect.left;
				tooltip.style.transform = `translateX(${overflow}px)`;
			}
		}

		initResponsiveWidth() {
			const imageContainer = document.querySelector('.image-with-hotspots[data-width-mobile]');
			if (!imageContainer) return;

			const updateWidth = () => {
				const mobileWidth = imageContainer.getAttribute('data-width-mobile');
				if (window.innerWidth <= 767 && mobileWidth) {
					imageContainer.style.setProperty('--mobile-width', `${mobileWidth}%`);
				}
			};

			updateWidth();
			window.addEventListener('resize', updateWidth);
		}

		initAutoOpen() {
			const imageContainer = document.querySelector('.image-with-hotspots');
			if (!imageContainer) return;

			const autoOpenDesktop = imageContainer.getAttribute('data-auto-open-desktop') === 'true';
			const autoOpenMobile = imageContainer.getAttribute('data-auto-open-mobile') === 'true';

			const applyAutoOpen = () => {
				const isMobile = window.innerWidth <= 767;
				const shouldAutoOpen = isMobile ? autoOpenMobile : autoOpenDesktop;

				if (shouldAutoOpen) {
					this.hotspots.forEach((hotspot) => {
						hotspot.classList.add('active', 'auto-opened');
					});
					// Add class to parent container for CSS styling
					this.classList.add('hotspots-auto-open');

					// Adjust tooltip positions on mobile
					if (isMobile) {
						setTimeout(() => {
							this.hotspots.forEach((hotspot) => {
								this.adjustTooltipPosition(hotspot.parentNode);
							});
						}, 50);
					}
				} else {
					// Only remove auto-opened ones, not user-clicked ones
					this.hotspots.forEach((hotspot) => {
						if (hotspot.classList.contains('auto-opened')) {
							hotspot.classList.remove('active', 'auto-opened');
						}
					});
					this.classList.remove('hotspots-auto-open');
				}
			};

			applyAutoOpen();
			window.addEventListener('resize', applyAutoOpen);
		}

		initAutoPlay() {
			const imageContainer = document.querySelector('.image-with-hotspots');
			if (!imageContainer) return;

			const autoPlayEnabled = imageContainer.getAttribute('data-auto-play') === 'true';
			if (!autoPlayEnabled) return;

			const duration = parseFloat(imageContainer.getAttribute('data-auto-play-duration') || 2) * 1000;
			let currentIndex = 0;
			let autoPlayInterval = null;
			let userInteracted = false;

			const hotspotsArray = Array.from(this.hotspots);
			if (hotspotsArray.length === 0) return;

			const playSequence = () => {
				// Close all hotspots first
				hotspotsArray.forEach(hotspot => {
					hotspot.classList.remove('active');
				});

				// Open current hotspot
				hotspotsArray[currentIndex].classList.add('active');
				hotspotsArray[currentIndex].parentNode.style.zIndex = this.zIndex++;

				// Move to next hotspot
				currentIndex = (currentIndex + 1) % hotspotsArray.length;
			};

			const stopAutoPlay = () => {
				if (autoPlayInterval) {
					clearInterval(autoPlayInterval);
					autoPlayInterval = null;
					userInteracted = true;
				}
			};

			// Start auto-play
			playSequence(); // Open first one immediately
			autoPlayInterval = setInterval(() => {
				if (!userInteracted) {
					playSequence();
				}
			}, duration);

			// Stop auto-play when user clicks any hotspot
			hotspotsArray.forEach(hotspot => {
				hotspot.addEventListener('click', (e) => {
					if (!userInteracted) {
						stopAutoPlay();
						// Close all first
						hotspotsArray.forEach(h => h.classList.remove('active'));
						// Then open the clicked one
						e.target.classList.add('active');
						e.target.parentNode.style.zIndex = this.zIndex++;
					}
				}, { capture: true });
			});

			// Also stop when clicking outside
			document.addEventListener('click', (e) => {
				if (!userInteracted && !e.target.closest('.image-hotspots__spot')) {
					stopAutoPlay();
					hotspotsArray.forEach(h => h.classList.remove('active'));
				}
			});
		}

  }

  if ( typeof customElements.get('image-hotspots') == 'undefined' ) {
    customElements.define('image-hotspots', ImageHotspots);
  }

}

if ( Shopify.designMode ) {
	document.addEventListener("shopify:block:select", (e) => {
		const block = e.target;
		if ( block.classList.contains(`.${this._prefix}image-hotspots__spot`) ) {
			const bulletElements = document.querySelectorAll(
				".image-hotspots__spot--bullet"
			);
			bulletElements.forEach((bulletElement) => {
				bulletElement.classList.remove("active");
			});
			const activeBullet = block.querySelector(`.${this._prefix}image-hotspots__spot--bullet`);
			activeBullet.classList.add('active');
		}
	})
}